import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BooleanCons, StringConst } from 'src/app/constants/const';
import {
  CloseDetailOrderData,
  OpenDetailOrderData,
} from 'src/app/model/local/general.model';
import { IProductDetailResponse } from '../../model/http/historyOrders.model';
import { CallPlace } from '../../model/http/myActivity.model';

@Component({
  selector: 'app-detail-order-dialog',
  templateUrl: './detail-order-dialog.component.html',
  styleUrls: ['./detail-order-dialog.component.scss'],
})
export class DetailOrderDialogComponent implements OnInit {
  response = new IProductDetailResponse();
  docNum = StringConst.empty;
  place = CallPlace.detailOrderList;
  isAuthorizeOrder = BooleanCons.false;
  isPaymentProcessed = BooleanCons.false;
  stringOrderId = StringConst.empty;
  statusOrder = StringConst.empty;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OpenDetailOrderData,
    private dialogRef: MatDialogRef<CloseDetailOrderData>
  ) {}

  ngOnInit(): void {
    this.docNum = this.data.orderId;
    this.place = this.data.callPlace;
    this.stringOrderId = this.data.stringOrderId ?? StringConst.empty;
    this.isAuthorizeOrder = this.data.isAuthorizeOrder;
    this.statusOrder = this.data.statusOrder ?? StringConst.empty;
    this.isPaymentProcessed = Boolean(this.data.isPaymentProcessed);
  }
  closeDialog(data: CloseDetailOrderData): void {
    this.dialogRef.close(data);
  }

  closeDialogEmpty(): void {
    this.dialogRef.close({ needsRefresh: true });
  }
}
